"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SideNav = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Nav = require("../Nav");

var _List = require("../List");

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var SideNav = function SideNav(_ref) {
  var className = _ref.className,
      children = _ref.children,
      listClassName = _ref.listClassName,
      whiteBackground = _ref.whiteBackground,
      ariaLabel = _ref.ariaLabel,
      props = _objectWithoutProperties(_ref, ["className", "children", "listClassName", "whiteBackground", "ariaLabel"]);

  var classes = (0, _classnames["default"])(className, "uxf-side-nav");
  var listClasses = (0, _classnames["default"])(listClassName, !whiteBackground && "card", "nav flex-column");
  return /*#__PURE__*/_react["default"].createElement(_Nav.Nav, _extends({
    className: classes,
    ariaLabel: ariaLabel
  }, props), /*#__PURE__*/_react["default"].createElement(_List.List, {
    className: listClasses
  }, children));
};

exports.SideNav = SideNav;
SideNav.propTypes = {
  /**
   * Applies white background to side navigation
   */
  whiteBackground: _propTypes["default"].bool,

  /**
   * Aria-label for navigation element.
   */
  ariaLabel: _propTypes["default"].string.isRequired,

  /**
   * Class name added to inner List component
   */
  listClassName: _propTypes["default"].string
};
SideNav.defaultProps = {
  whiteBackground: false
};